import { Injectable, inject } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { tap } from 'rxjs';
import { MessageLogger } from '../../logging/interfaces/message-logger.interface';
import { IToastie, isToastieAction } from '../models/toastie.model';

@Injectable()
export class ToastLoggingEffect {
  private readonly actions$ = inject(Actions);
  private readonly messageLogger = inject(MessageLogger);

  toastLoggingEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        tap((action) => {
          if (isToastieAction(action)) {
            try {
              this.logToast(action);
            } catch {
              // Intentionally empty - don't let logging failures break the app
            }
          }
        })
      );
    },
    { dispatch: false }
  );

  private logToast(action: Action & { toast: IToastie; error?: unknown }): void {
    const { toast } = action;

    if ('message' in toast) {
      this.messageLogger.logMessage(toast.message);
    }
  }
}
